import React from "react";

// ------------------------------------------------------------------
// Boston Iron Grit brand logo (owner-supplied horizontal lockup:
// dumbbell + heartbeat mark, wordmark, "We Build Strong Humans").
// Recolored for dark (light) and light (crimson) surfaces.
// ------------------------------------------------------------------

export function LogoMark({ className = "h-10 w-auto", variant = "light" }) {
  return (
    <img
      src={`/images/brand/mark-${variant}.png`}
      alt=""
      aria-hidden="true"
      width="480"
      height="207"
      className={`${className} object-contain`}
    />
  );
}

export default function Logo({ size = "md", variant = "light" }) {
  const cls = size === "sm" ? "h-9" : "h-10 lg:h-11";
  return (
    <img
      src={`/images/brand/logo-horizontal-${variant}.png`}
      alt="Boston Iron Grit — We Build Strong Humans"
      width="1200"
      height="254"
      className={`${cls} w-auto object-contain`}
    />
  );
}
